import { Link, useNavigate } from 'react-router-dom';
import { Check, Zap, ShieldCheck, Laptop } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { useDiagnosticContext } from '../context/DiagnosticContext';
import styles from './Pricing.module.css';

export const Pricing = () => {
  const { user, profile } = useAuth();
  const navigate = useNavigate();
  const { resetDiagnostic } = useDiagnosticContext();

  const handleStart = (e: React.MouseEvent) => {
    e.preventDefault();
    resetDiagnostic();
    navigate('/diagnostic');
  };

  const getPricingLink = (tier: string) => {
    if (!user) {
      return `/login?redirect=/pricing&tier=${tier}`;
    }
    return `/pricing`; // Or direct to checkout if we want
  };

  return (
    <section id="pricing" className={styles.section}>
      <div className="wrap">
        <div className="section-header">
          <div className="section-label">Pricing</div>
          <h2>One-time payment. No subscriptions.</h2>
        </div>

        {user && profile && profile.credits > 0 ? (
          <div className={styles.card} style={{ maxWidth: '600px', margin: '0 auto' }}>
            <div className={styles.icon}><ShieldCheck size={24} /></div>
            <h3>Ready to Scan</h3>
            <p className={styles.note}>You have <strong>{profile.credits} report credits</strong> remaining.</p>
            <button onClick={handleStart} className={styles.btn} style={{ marginBottom: '16px', border: 'none', cursor: 'pointer', width: '100%' }}>
              Run Full AI Diagnostic <Zap size={16} />
            </button>

            <Link to="/pricing" style={{ color: 'var(--text-2)', fontSize: '14px', textDecoration: 'underline' }}>
              Buy more credits
            </Link>
          </div>
        ) : (
          <>
            <div className={styles.grid}>
              {/* Tier 1 */}
              <div className={styles.card}>
                <div className={styles.icon}><Laptop size={24} /></div>
                <h3>Single Report</h3>
                <div className={styles.amount}><sup>£</sup>4.99</div>
                <p className={styles.note}>1 PC Health Report</p>
                <ul className={styles.features}>
                  <li><Check size={16} /> Full AI-powered analysis</li>
                  <li><Check size={16} /> Prioritised fix list</li>
                  <li><Check size={16} /> Downloadable PDF</li>
                  <li><Check size={16} /> Secure Stripe payment</li>
                </ul>
                <Link to={getPricingLink('single')} className={styles.btn}>
                  Get Report <Zap size={16} />
                </Link>
              </div>

              {/* Tier 2 */}
              <div className={`${styles.card} ${styles.featured}`}>
                <div className={styles.badge}>Best Value</div>
                <div className={styles.icon}><ShieldCheck size={24} /></div>
                <h3>Family Pack</h3>
                <div className={styles.amount}><sup>£</sup>9.99</div>
                <p className={styles.note}>3 PC Health Reports</p>
                <ul className={styles.features}>
                  <li><Check size={16} /> All Single Report features</li>
                  <li><Check size={16} /> Use on multiple PCs</li>
                  <li><Check size={16} /> Re-scan after fixes</li>
                  <li><Check size={16} /> Credits never expire</li>
                </ul>
                <Link to={getPricingLink('family')} className={styles.btn}>
                  Get Family Pack <Zap size={16} />
                </Link>
              </div>
            </div>

            <p className={styles.footerText}>
              Secure payment via Stripe. Your data is encrypted and auto-deleted after 7 days.
            </p>
          </>
        )}
      </div>
    </section>
  );
};
